export const environment = {
  production: false,
  envName: 'staging',
  apiPath: '//apidevops.simeza.com/v1',
  allowedHostOrigins: ['http://portaldev.simeza.com', 'https://portaldev.simeza.com']
};
